var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }